export default "__VITE_ASSET__BrcQx59O__"